export class GeneralErrorService {
  private static instance: GeneralErrorService

  private isVisible: boolean
  private listeners: Set<(isVisible: boolean) => void>

  private constructor() {
    this.isVisible = false
    this.listeners = new Set()
  }

  private notify() {
    for (const listener of this.listeners) {
      try {
        listener(this.isVisible)
      } catch {
        // ignore listener errors to avoid breaking global error handling
      }
    }
  }

  subscribe(listener: (isVisible: boolean) => void): () => void {
    this.listeners.add(listener)

    // Immediately emit current state so subscribers can sync without extra calls
    try {
      listener(this.isVisible)
    } catch {
      // ignore
    }

    return () => {
      this.listeners.delete(listener)
    }
  }

  setIsVisible(isVisible: boolean) {
    // Avoid redundant notifications
    if (this.isVisible === isVisible) return

    this.isVisible = isVisible
    this.notify()
  }

  getIsVisible(): boolean {
    return this.isVisible
  }

  static getInstance(): GeneralErrorService {
    if (!GeneralErrorService.instance) {
      GeneralErrorService.instance = new GeneralErrorService()
    }

    return GeneralErrorService.instance
  }
}
